export default "__VITE_ASSET__CDSBZRnW__"